import { Box, Container, Flex, Text, Icon } from '@chakra-ui/react';
import { FiCheckCircle } from 'react-icons/fi';
import { CONTAINER_MAX_WIDTH_1 } from 'src/constants/ui';

export const LiveListingBanner = () => {
  return (
    <Box as="section" w="full">
      <Box bg="green.50" borderBottomWidth="1px" borderColor="green.200" w="full">
        <Container maxW={CONTAINER_MAX_WIDTH_1} py="10px">
          <Flex
            align="center"
            justify={{ base: 'start', md: 'center' }}
            gap="3"
            direction={{ base: 'column', md: 'row' }}
            textAlign={{ base: 'left', md: 'center' }}
          >
            <Flex align="center" gap="2">
              <Icon as={FiCheckCircle} color="green.600" boxSize="5" />
              <Text fontWeight="semibold" color="green.800">
                Your listing is live!
              </Text>
            </Flex>
          </Flex>
        </Container>
      </Box>
    </Box>
  );
};

export default LiveListingBanner;
